<template>
    <div class="condition-search-wrapper">
        <div class="index-class-menu">
            <div class="search-input">
                <slot name="right"></slot>
                <input :placeholder="placeholder" v-model="searchInfo" type="text" @input="inputChange" />
                <i class="i-search" @click.self="search"></i>
                <i class="i-s-del" @click.self="emptySearch" v-show="searchInfo != ''"></i>
            </div>
        </div>
        <div class="select-list" v-show="isShowOptions">
            <input type="text" @change="getListInfo" v-model="conditionInfo" v-show="hasInput" />
            <ul class="select-options scroll-tracker">
                <!--选中高亮li+on-->
                <li v-for="(item, idx) in resData" :key="idx" @click="getSelected(item)">{{ item }}</li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: "ConditionSearch",
    props: ["resData", "placeholder", "hasInput"],
    data() {
        return {
            conditionInfo: "",
            isShow: false,
            searchInfo: ""
        };
    },
    computed: {
        isShowOptions() {
            return this.isShow && this.resData && this.resData.length;
        }
    },
    methods: {
        getListInfo() {
            if (this.conditionInfo != "") {
                this.$emit("conditionInputChange", {
                    keywords: this.conditionInfo
                });
            }
        },
        getSelected(item) {
            this.$emit("conditionInputChange", {
                keywords: item
            });
            this.searchInfo = item;
            this.isShow = !this.isShow;
        },
        emptySearch() {
            let searchInfo = this.searchInfo;
            this.isShow = false;

            if (searchInfo != "") {
                this.searchInfo = "";
                this.$emit("searchInputChange", {
                    keywords: this.searchInfo
                });
            }

            return false;
        },
        search() {
            let searchInfo = this.searchInfo;
            this.isShow = false;
            if (searchInfo != "") {
                this.$emit("searchInputChange", {
                    keywords: this.searchInfo
                });
            }
        },
        inputChange() {
            this.isShow = this.searchInfo ? true : false;

            this.$emit("showSearchList", {
                searchInfo: this.searchInfo
            });
        }
    }
};
</script>

<style scoped lang="less">
.condition-search-wrapper {
    width: 100%;
    max-height: 400px;
    box-sizing: border-box;
    background: #fff;
    overflow: hidden;
    li {
        padding: 6px 12px;
        cursor: pointer;
        &:hover,
        &.on {
            background: #e4f1f9;
            color: #2ec2ff;
        }
    }

    .search-input {
        width: 100%;
        padding: 1px 0 2px;
        position: relative;
        border-radius: 4px;
        border: 1px solid #d8e4f0;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        input {
            width: 100%;
            box-sizing: border-box;
            margin: 4px 8px 5px;
            border-radius: 4px;
            color: #41475e;
            outline: none;
        }
    }
    .select-options {
        max-height: 250px;
        overflow-y: auto;
    }
}
.select-list {
    box-sizing: border-box;
    box-shadow: 0 0 8px 0 rgba(90, 98, 111, 0.25);
    margin-bottom: 5px;
    padding-top: 5px;
    position: absolute;
    background: #fff;
    width: 100%;
    z-index: 1;
    input {
        border: 1px solid #d8e4f0;
        height: 35px;
        width: 98%;
        margin: 0 1%;
        background: #fff;
        border-radius: 4px;
        color: #41475e;
        outline: none;
        padding: 5px;
    }
}

.i-search,
.i-s-del {
    position: absolute;
    display: inline-block;
    background: url("@{zhijiStaticImagePath}class-spr.png");
    top: 50%;
    margin-top: -9px;
    width: 18px;
    height: 18px;
    cursor: pointer;
}

.i-s-del {
    right: 35px;
    background-position: -4px -1px;
}

.i-search {
    right: 10px;
    vertical-align: middle;
    background-position: -252px 0;
    opacity: 0.7;
}

.i-search:hover {
    opacity: 1;
    background-position: -89px -113px;
}

.i-s-del:hover {
    background-position: -252px -20px;
}
</style>
